import PropTypes from 'prop-types'
import _ from 'lodash'
import { Alert } from 'antd'
import { useStepRunState } from '../hooks/useSteps'
import useStepError from '../hooks/useStepError'
import styles from './ExternalErrorStep.css'

const ExternalErrorStep = ({ children }) => {
  const { loadingStep, successStep } = useStepRunState()
  const [stepError] = useStepError()

  if (!loadingStep && !successStep && stepError) {
    const message = _.get(stepError, 'message', `錯誤：${_.toString(stepError)}`)

    return (
      <div className={styles.stepErrorWrapper}>
        <Alert
          type='error'
          message='發生錯誤'
          description={message}
          showIcon
        />
      </div>
    )
  }

  return children
}

ExternalErrorStep.propTypes = {
  children: PropTypes.node
}

export default ExternalErrorStep
